import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import React, { Component } from 'react';
import { NumberCell } from '../../../utils/Cells';

class LinkRow extends Component {
    componentDidMount() {
        console.log(this.props)
    }

    render() {
        return (
            <TableContainer component={Paper}>
                <Table size="small" aria-label="a dense table">
                    <TableHead>
                        <TableRow>
                            <TableCell>Sorszám</TableCell>
                            <TableCell>Megnevezés</TableCell>
                            <TableCell>Link Összege</TableCell>
                            <TableCell>Tranzakció megjegyzés</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow key="new">
                            <TableCell> {this.props.row.payable.publicId}</TableCell>
                            <TableCell>{this.props.row.payable.partnerName}</TableCell>
                            <TableCell align="right"><NumberCell value={this.props.row.amount} /></TableCell>
                            <TableCell>{this.props.row.transaction.comment}</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        )
    }
}
export default LinkRow;